/**
 * useVendorAuth Hook
 *
 * Custom hook to access VendorAuthContext from child components.
 * Throws error if used outside VendorAuthProvider.
 *
 * Returns UserInfoDto (from OpenAPI) for the authenticated supplier.
 *
 * Usage:
 * ```typescript
 * const { currentUser, logout } = useVendorAuth()
 * ```
 */

import { useContext } from "react";
import {
  VendorAuthContext,
  VendorAuthContextType,
} from "../contexts/VendorAuthContext";

export function useVendorAuth(): VendorAuthContextType {
  const context = useContext(VendorAuthContext);
  if (!context) {
    throw new Error("useVendorAuth must be used within VendorAuthProvider");
  }
  return context;
}
